export default __webpack_public_path__ + "static/media/book.5950e34f.png";